import { defineAction } from '~/prix'
import { z } from 'zod'
import userFileReadAction from './userFileRead.action.json' with { type: 'json' }

const userFileReadDefinition = defineAction({
  ...userFileReadAction,

  input: z.object({
    path: z.string().describe('Caminho do arquivo na pasta do usuário'),
    disposition: z
      .enum(['inline', 'attachment'])
      .default('inline')
      .describe('Tipo de disposição do arquivo'),
  }),
  output: z.any(),
})

export default userFileReadDefinition
